var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.specialOrderDiscountCountDown != '')?_c('div',{staticClass:"p-2 m-3 rounded alert alert-danger text-center border border-dark"},[_c('i',{staticClass:"icon-gift"}),_c('small',{staticClass:"text-center ml-2",domProps:{"innerHTML":_vm._s(
          _vm.$t('lang.orders.specialorderdiscount', {
            discount_end_date: _vm.getSpecialOrderDiscountEndDate(),
            discount_countdown: _vm.specialOrderDiscountCountDown,
          })
        )}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }